import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { WORKSHOPS_OPTIONS, EventResponse } from '../../../constants';
import EventListView from '../../searchResult';
import { Creators as eventScrollActions } from '../../../../../../domain/useCases/events/getEventsUseCase/getEventsByStudentScroll';
import { EventsDataProps } from './events.interface';

interface InscriptionsProps {
  current: number;
  handleTab: (selected: number) => void;
  selectEvent: (eventId: number, typeEvent: string) => void;
  tabTitle: string;
  setCounterSubscriptions: (counterSubscriptions: number) => void;
}

const Inscriptions = (props: InscriptionsProps) => {
  const { current, handleTab, selectEvent, tabTitle, setCounterSubscriptions } =
    props;
  const [page] = useState(1);
  const dispatch = useDispatch();

  const { data, showMore, isLoading } = useSelector(
    (state: any) => state?.getEventsByStudentScroll
  );

  const { events }: EventsDataProps = data?.eventsScrollType ?? {};
  useEffect(() => {
    if (!isLoading) {
      const counterSubscription = events.filter(
        (event) => event.isSubscribed
      ).length;
      setCounterSubscriptions(counterSubscription);
      sessionStorage.setItem(
        'counterSubscriptions',
        String(counterSubscription)
      );
    }
  }, [events]);

  const tabNumberToType = (tabNumber: number) =>
    Object.values(EventResponse)[tabNumber - 1];

  useEffect(() => {
    dispatch(
      eventScrollActions.getEventsByStudentScroll(
        tabNumberToType(current),
        page
      )
    );
  }, [page]);

  return (
    <EventListView
      options={WORKSHOPS_OPTIONS}
      isLoading={isLoading}
      handleTab={handleTab}
      selectEvent={selectEvent}
      tabTitle={tabTitle}
      current={current}
      eventType="inscritos"
      loadMoreEvents={() => {}}
      showMore={showMore}
      data={data}
    />
  );
};

export default Inscriptions;
